import { Button } from "../ui/button";
import { useContext } from "react";
import { LanguageContext } from "../languageContext";

export default function MapInstructionsCard({
  resetMap,
  startID,
  endID,
}: {
  resetMap: () => void;
  startID: string | number | null;
  endID: string | number | null;
}) {
  const { translate } = useContext(LanguageContext);
  const getHeader = () => {
    if (!startID) {
      return translate("selectStartBlock");
    }
    if (!endID) {
      return translate("selectEndBlock");
    }
    return translate("compareTravelTimes");
  };

  return (
    <div className="flex space-x-4 items-center z-0">
      <div className="bg-white p-4 rounded-lg shadow-md max-w-[300px] border space-y-1">
        <h2 className="text-lg font-bold">{getHeader()}</h2>
        {startID && endID && (
          <p className="text-sm text-gray-500">{translate("viewTableBelow")}</p>
        )}
      </div>
      {(startID || endID) && (
        <Button onClick={resetMap} tabIndex={0}>
          {translate("reset")}
        </Button>
      )}
    </div>
  );
}
